// extracted by mini-css-extract-plugin
export default {"melodyVideo":"aM-z","isFullWidth":"bM-z","landingPageVideo":"cM-z","play":"dM-z","iframeVideo":"eM-z","playHidden":"fM-z","fullwidth":"gM-z"};